function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
      	$('.cart-bubble').html(cart_count);
        $('.cart-bubble').addClass('active');
      }else{
        $('.cart-bubble').html('');
        $('.cart-bubble').removeClass('active');      	
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
$(document).on('click','.item-remove',function (e) {
  e.preventDefault();
  let data_line = $(this).data('line');
  removeItem(data_line,0);
});
$(document).on('click','.cart-drawer-close,.h_carturl',function (e) {
  e.preventDefault();
  $('body').toggleClass('open-drawer');
});
$(document).on('click','.overlay-box',function (e) {
  $('body').removeClass('open-drawer');
});
$(document).on('click','.ci_plus a', function (e) {
  e.preventDefault();
  var $qty = $(this).closest('.ci_qtybox').find(".cart_qty");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal)) {
    $qty.val(currentVal+1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.ci_plus').data('line');
    removeItem(data_line,input_qty);
  }
});
$(document).on('click','.ci_minus a', function (e) {
  e.preventDefault();
  var $qty = $(this).closest('.ci_qtybox').find(".cart_qty");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.ci_minus').data('line');
    removeItem(data_line,input_qty);
  }
});